export default __webpack_public_path__ + "static/media/icon_university.5f6c8b94.png";